import React, { useEffect, useMemo, useState } from 'react'
import { ManualPaymentScreen } from '@/components/pages/self-checkin/payment/manual-payment-screen'
import { useSelfCheckInState } from '@/hooks/use-self-check-in-state'
import { TerminalPaymentScreen } from '@/components/pages/self-checkin/payment/terminal-payment-screen'

export const CheckinPayment: React.FC = () => {
  const { state, stateErrorHandling } = useSelfCheckInState()
  const [isInitializeComponent, setIsInitializeComponent] = useState(false)

  useEffect(() => {
    window.scrollTo(0, 0)
    if (!stateErrorHandling(state, 'confirm')) {
      return
    }
    setIsInitializeComponent(true)
  }, [])

  const isEnabledTerminal = useMemo(() => {
    return state?.setting?.isEnabledPaymentTerminal || state?.setting?.isEnabledCashChanger
  }, [])

  if (!isInitializeComponent) {
    return <></>
  }

  return isEnabledTerminal ? <TerminalPaymentScreen /> : <ManualPaymentScreen />
}
